var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-list',{class:_vm.$style.list},[_c('ListInputText',_vm._g(_vm._b({class:_vm.$style.input,attrs:{"slot":"list"},slot:"list"},'ListInputText',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }